import React, { ComponentType, FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import useCurrentUser from '../hooks/useCurrentUser';
import { hasLegacyClientsViewAccess } from './routePermissions';

// The legacy Clients view (V1) was replaced by the funnel's Table view; old links (copied client links,
// bookmarks) still point here, so a client link opens that client with its chat in the Table view.
export const getTableViewPathFromLegacyClients = (pathname: string, search: string): string => {
  const params = new URLSearchParams({ view: 'table' });
  const projectId = new URLSearchParams(search).get('projectId');
  if (projectId) params.set('projectId', projectId);

  const clientMatch = pathname.match(/^\/clients\/(\d+)/);
  if (clientMatch) {
    params.set('client', clientMatch[1]);
    params.set('chat', 'side');
  }
  return `/funnel?${params.toString()}`;
};

// Admins keep direct access; everyone else only gets in from the sidebar or the Table view's back button.
const withLegacyClientsViewAccess = (Component: ComponentType): FC => {
  const LegacyClientsViewGuard: FC = () => {
    const { pathname, search, state } = useLocation();
    const currentUser = useCurrentUser();

    if (currentUser?.isAdmin || hasLegacyClientsViewAccess(state)) return <Component />;
    return <Navigate to={getTableViewPathFromLegacyClients(pathname, search)} replace />;
  };
  return LegacyClientsViewGuard;
};

export default withLegacyClientsViewAccess;
